import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['alternatives', 'student', 'sidebar', 'warningContainer', 'input'];
  static values = { count: Number, isOpen: Boolean };

  connect() {
    this.CHANGES_TO_UPDATE = 10;
    this.requestQueue = [];
    this.sendingRequest = false;
    this.requestPath = '';

    if (this.hasSidebarTarget) {
      this.isOpenValue = window.getComputedStyle(this.sidebarTarget).width !== '0px';
    }

    super.connect();
  }

  updateResponses() {
    if (this.requestQueue.length > 0 && !this.sendingRequest) {
      // Ajax Call
      const data = this.requestQueue;
      this.requestQueue = [];
      this.sendingRequest = true;
      $.ajax({
        beforeSend: (xhr) => {
          xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
        },
        type: 'patch',
        dataType: 'json',
        url: this.requestPath,
        data: { responses: data },
        complete: () => {
          this.sendingRequest = false;
          if (this.requestQueue.length >= this.CHANGES_TO_UPDATE) {
            this.updateResponses();
          }
        },
        error: (e) => {
          location.reload();
          const errorMessage =
            e.responseJSON?.error?.message || e.responseJSON?.message || 'Erro desconhecido';
          alert(`Error ao salvar resposta: ${errorMessage}`);
        },
      });
    }
  }

  updateScores(event) {
    const hideClass = 'd-none';
    const loadingElement = document.getElementById('loading-response');
    if (loadingElement) {
      loadingElement.classList.remove(hideClass);
    }

    this.requestPath = this.alternativesTarget.dataset.way;

    const responseAttrs = {
      student_id: document.getElementById(event.params.number).value,
      exams_question_id: document.getElementById(event.params.question).value,
      alternative: event.target.value,
    };

    // Check if the user changes the response of other student
    if (this.requestQueue.length !== 0) {
      const studentChanged =
        this.requestQueue[this.requestQueue.length - 1].student_id !== responseAttrs.student_id;
      if (studentChanged) {
        this.updateResponses();
      }
    }

    this.requestQueue.push(responseAttrs);

    if (this.requestQueue.length >= this.CHANGES_TO_UPDATE) {
      this.updateResponses();
    }
  }

  toggleSidebarResponse() {
    if (!this.hasSidebarTarget) {
      return;
    }

    const children = this.sidebarTarget.children;
    const isMediumScreen = window.matchMedia('(min-width: 768px)').matches;
    const openWidth = isMediumScreen ? '550px' : '100vw';

    // Aplicar transições (melhor fazer isso no CSS)
    for (let i = 0; i < children.length; i++) {
      children[i].style.transition = 'opacity 0.25s ease-in-out';
    }

    if (!isMediumScreen) {
      this.sidebarTarget.classList.add('tw-z-20', 'tw-absolute');
    } else {
      this.sidebarTarget.classList.remove('tw-z-20', 'tw-absolute');
    }

    if (!this.isOpenValue) {
      // Abrir sidebar
      this.sidebarTarget.style.width = openWidth;
      this.sidebarTarget.style.padding = '32px';
      setTimeout(() => {
        for (let i = 0; i < children.length; i++) {
          children[i].style.opacity = '1';
        }
      }, 300);
    } else {
      // Fechar sidebar
      this.sidebarTarget.style.width = '0px';
      this.sidebarTarget.style.padding = '0px';
      for (let i = 0; i < children.length; i++) {
        children[i].style.opacity = '0';
      }
    }
    // Alternar estado
    this.isOpenValue = !this.isOpenValue;
  }

  checkMissingResponses() {
    if (!this.hasWarningContainerTarget) return;

    let missingCount = 0;

    this.inputTargets.forEach((select) => {
      //colocamos essa linha porque  o componente de input duplica o target em outras tags como div
      if (select.tagName != 'INPUT' && select.tagName != 'SELECT') {
        return;
      }

      if (!select.value || select.value === '') {
        missingCount++;
      }
    });

    if (missingCount > 0) {
      this.warningContainerTarget.style.display = '';
    } else {
      this.warningContainerTarget.style.display = 'none';
    }
  }
}
